import styled from 'styled-components';
import { TITLE_ON_TRUNCATE_CLASSNAME } from './constants';

export const StyledTitleOnTruncate = styled.div.attrs({
  className: TITLE_ON_TRUNCATE_CLASSNAME,
})`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;
